<footer class="default">
  &copy; 2004 -
  <span [innerHtml]="currentYear || 2019"> </span>
  Junction Networks. All Rights Reserved.
</footer>
